export default __webpack_public_path__ + "static/media/domino_counter_screen_6.5e797046.png";